import { IconWrapper } from '../runtime';
export default IconWrapper('mind_mapping_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#009BBA"
    }
  }), h("path", {
    "attrs": {
      "d": "M2 16C0.895431 16 0 15.1046 0 14L16 14C16 15.1046 15.1046 16 14 16L2 16Z",
      "fill": "#0086A0"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 16L8 14L16 14C16 15.1046 15.1046 16 14 16L8 16Z",
      "fill": "#09B2D4"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.75 5.00234H9V6.25H12V2.75H7.5L6.5 4H10.75V5.00234Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3 5.00234V9.00234H8V5.00234H3ZM6.75 6.25H4.25V7.75H6.75V6.25Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M10.75 9.00234H9V7.75H12V11.25H7.5L6.5 10H10.75V9.00234Z",
      "fill": "white"
    }
  })]);
});